<template>
  <PageLayoutWrapper
    page="departments/_id/faculty"
    :props="{...$props, professors }"
  >
    <BaseTable
      :rows="professors"
      resource-name="Instructors"
    >
      <template #header>
        <th class="th">Name</th>
        <th class="th">Email</th>
      </template>
      <template #default="{ row: professor }">
        <td>
          {{ professor.firstName + ' ' + professor.lastName }}
        </td>
        <td>
          {{ professor.email }}
        </td>
      </template>
    </BaseTable>
  </PageLayoutWrapper>
</template>

<script>
import _sortBy from 'lodash/sortBy'
import { safeEncodeURIComponent } from '@/utils/generalUtils'
import PageLayoutWrapper from '@/components/PageLayoutWrapper'
import useMeta from '@/composables/useMeta'
export default {
  components: {
    PageLayoutWrapper,
  },
  props: {
    department: {
      type: Object,
      required: true,
    },
    availableColumns: {
      type: Array,
      default: () => [
        {
          id: 'Name',
        },
        {
          id: 'E-mail',
        },
      ],
    },
  },
  setup() {
    const { catalogWideMetaTitle } = useMeta()
    return { catalogWideMetaTitle }
  },
  async asyncData({ params, $bugsnag, $axios, redirect, store }) {
    try {
      const instructorsFilters = store.state.settings.instructorsFilters
      const hasFilters =
        instructorsFilters?.filters && instructorsFilters?.filters.length > 0
      if (hasFilters) {
        const url = `/${
          store.state.settings.school
        }/professors/search?searchQuery=$filters&catalogDepartments=${
          safeEncodeURIComponent(params.id)
        }`
        const data = await $axios.$post(url, {
          ...instructorsFilters,
        })

        const professors = Object.values(data || {})
        return { professors }
      } else {
        let professors = await $axios.$get(
          `/${store.state.settings.school}/professors`,
          {
            params: {
              catalogDepartments: safeEncodeURIComponent(params.id),
            },
          }
        )

        professors = _sortBy(Object.values(professors), [
          'lastName',
          'firstName',
          'email',
        ])
        return {
          professors,
        }
      }
    } catch (e) {
      $bugsnag.notify(e)
      redirect('/404')
    }
  },
  head() {
    return {
      title: `${this.department.displayName} Department Faculty | ${
        this.catalogWideMetaTitle
      }`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `${this.department.displayName} Department Faculty | ${
            this.catalogWideMetaTitle
          }`,
        },
      ],
    }
  },
}
</script>
